<script setup lang="ts">
import { Avatar } from '@dashhudson/dashing-ui/avatar';
import { Icon } from '@dashhudson/dashing-ui/icon';

import type { Collaborators } from '@/app/analytics/types';

defineProps<{
  collaborators: Collaborators;
}>();
</script>

<template>
  <div class="flex min-w-[172px] flex-col gap-4">
    <div class="flex items-center gap-1">
      <span class="typo-base-semibold">Collaborators</span>
      <Icon
        v-dash-tooltip="
          'The brands and creators who collaborated on this post. The collaborator listed first is the primary author.'
        "
        name="info-circle"
        :size="16"
      />
    </div>
    <div class="flex flex-col">
      <div
        v-for="collaborator in collaborators"
        :key="collaborator.username"
        class="flex items-center gap-2 py-2"
      >
        <Avatar :image="collaborator.avatarUrl" size="sm" />
        <span class="typo-base">{{ collaborator.username }}</span>
      </div>
    </div>
  </div>
</template>
